import React, { useEffect } from 'react';
import styled from "styled-components";
import BackButton from '../common/BackButton';

const Container = styled.div<{ open: boolean, animate?: boolean }>`
    background: var(--page-bg);
    height: 100%;
    overflow-y: auto;
    position: fixed;
    right: ${(props) => (props.open ? '0' : '-100%')};
    top: 0;
    ${props => props.animate !== false ? 'transition: right 0.3s ease-in-out;' : ''}
    width: 100%;
    z-index: 1000;
`;

export interface PanelContainerProps {
    animate?: boolean;
    children: React.ReactNode;
    onClose?: () => void;
    open?: boolean;
    title?: string | React.ReactNode;
}

const SidebarPanel: React.FC<PanelContainerProps> = (props) => {
    const [loaded, setLoaded] = React.useState(false);
    const [open, setOpen] = React.useState(false);

    useEffect(() => {
        if (!loaded) {
            setTimeout(() => {
                setLoaded(true);
                setOpen(true);
            }, 10);
        }
    }, [loaded]);

    return (
        <Container open={open} animate>
            <div className="container pad-y">
                <BackButton onBackClick={props.onClose}>Volver</BackButton>
                <h2 className="title-1 mt-5">{props.title}</h2>
                {props.children}
            </div>
        </Container>
    );
};

export default SidebarPanel;